// @flow
import React, { Component } from 'react'
import { translateFunc, translations } from '../../shared/localize'
import LabeledWrapper from './LabeledWrapper'
import SingleDatePicker from '../../shared/single.datepicker'
import $ from 'jquery'

type Props = {|
  label: string,
  value?: string,
  errors: Array<string>,
  value: string,
  hide?: boolean,
  minDate: string,
  onChange: (string) => void
|}

const t = translateFunc(translations.audience_edit.finish_date)

export default class FinishDate extends Component<Props> {
  finishDateInput: any

  datepickerChanged(date: string) {
    this.props.onChange(date)
  }

  render() {
    if (this.props.hide) return null

    return (
      <LabeledWrapper label={this.props.label} errors={this.props.errors} twoLines>
        <input
          ref={(ref: any) => {
            this.finishDateInput = ref
          }}
          type="text"
          className="audience-form-finish-date date-input"
          value={this.props.value || ''}
          onChange={(event) => {
            this.props.onChange(event.target.value)
          }}
          data-min-date={this.props.minDate}
          data-clear-button-text={t('clear')}
          data-empty-value-text={t('empty')}
        />
      </LabeledWrapper>
    )
  }

  componentDidMount() {
    new SingleDatePicker($(this.finishDateInput), (date) => this.datepickerChanged(date)).wrap()
  }
}
